export const meta = {
  id: 'CFR',
  name: 'Cross franchise return',
  keywords: ['cross', 'franchise', 'return'],
  info:
    'This plugin is used to process returns accross multiple locations within a franchise structure account.',
};
